import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import '../../components/table.css';
import CircularProgress from '@mui/material/CircularProgress';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import Sellerpagination from "../../components/Paginated/Sellerpagination";
import brandStyles from "../Brand/Brand.module.css";
import styles from "./UserList.module.css";
import "../../components/mcrbTableTheme.css";
const { apiEndpoint } = config;
var $ = require('jquery');

var count = 1;
const UserList = () => {
    const [userlist, setUserList] = useState([]);
    const [userloading, setuserLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sellerList, setSellerList] = useState([]);
    const rawData = {
        seller_id: ''
    }
    const [searchData, setSearchData]: any = useState(rawData);
    const decode = tokenDecode();
    const { data } = decode;
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const fetchUserList = async () => {

        let parentId = decode?.data?.user?.parent_id;
        let SellerId = decode?.data?.user?.seller_id;
        let payload;
        if (parentId > 1) {
            payload = { seller_id: parentId }

        } else {
            payload = { seller_id: SellerId }

        }
        try {
            setuserLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/getuserlist`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: payload
            });
            // console.log("user listing", data);
            setuserLoading(false);
            if (data.status === 200) {
                setUserList(data.data);
            }
            setTimeout(() => {
                $('#dataTable').DataTable();
            }, 500)
        } catch (error) {
            setuserLoading(false)
        }
    }
    const userDelete = async (id: any) => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/userdelete`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { id }
            });
            // console.log("data----", data);
            if (data.status === 200) {
                setUserList(userlist.filter((item: any) => item.id !== id));
                toast.success("User deleted !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("403 Error !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }
    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        try {

            var optionvalue = e.target.value;
            setSearchData({ ...searchData, [e.target.name]: e.target.value });
            // console.log(optionvalue);
            const { data } = await axios({
                url: `${apiEndpoint}/getuserfilterbyseller`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    seller_id: optionvalue
                }

            });

            if (data.status === 200) {
                // console.log(data);
                setUserList(data.data);
            }


        } catch (error) {
            console.log("error", error);
        }
    };
    const COLUMNS = [
        {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Name",
            Footer: "Name",
            accessor: "name",
            sticky: "left"
        },
        {
            Header: "Email",
            Footer: "Email",
            accessor: "email",
            sticky: "left"
        },
        {
            Header: "Contact",
            Footer: "Contact",
            accessor: "contact_no",
            sticky: "left"
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => (
                <span className={row.status ? brandStyles.statusBadgeActive : brandStyles.statusBadgeInactive}>
                    {row.status ? "Active" : "Deactive"}
                </span>
            ),
            sticky: "left"
        },

        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                        {user.update ? (
                            <Link to={`../../updateuser/${row.id}`} className={brandStyles.iconBtn}>
                                <EditNoteRoundedIcon style={{ color: "#4c2fb3" }} titleAccess="Update" />
                            </Link>
                        ) : null}
                        {user.delete ? (
                            <span className={brandStyles.iconBtn} onClick={() => userDelete(row.id)}>
                                <DeleteIcon style={{ color: "#EF4444", fontSize: 20 }} titleAccess="Delete" />
                            </span>
                        ) : null}
                    </div>
                )
            },
            sticky: "left"
        },

    ];
    count++
    useEffect(() => {
        // $('#dataTable').DataTable();
        fetchUserList();
        getSellerList();
    }, [])
    const [searchValue, setsearchValue] = useState("")
    const masterSearchHandler = async (e: any) => {
        let searchedData = e.target.value;
        setsearchValue(searchedData)

        let dataToSend = {
            title: searchedData
        }
        // console.log(dataToSend)
        try {
            const { data } = await axios({
                url: "https://shikahrapp.hulsecure.in/public/index.php/api/searchUserFilter",
                method: "post",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: dataToSend
            })
            // console.log("Response from Server-------------", data)
            if (data.status == 200) {
                setUserList(data.message)
            } else {
                // console.log("Search API is not running!!");
            }

        } catch (err) {
            console.log(err)
        }

    }
    return (
        <>
            <ThemeMaker>
                <div className={`${styles.pageWrap} mcrb-page`}>
                    <div className={`${brandStyles.cardOuter} mcrb-card`}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>User List</span>
                        </div>

                        <div className={styles.toolbarRow}>
                            <div className={styles.searchInput} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <SearchIcon style={{ fontSize: 18, color: "#9CA3AF" }} />
                                <input
                                    type="search"
                                    name="name"
                                    placeholder="Search User"
                                    style={{ border: "none", outline: "none", background: "transparent", width: "100%", fontSize: "13.5px" }}
                                    value={searchValue}
                                    onChange={masterSearchHandler}
                                />
                            </div>
                            {/* {seller?.read ?
                                <div className={styles.sellerListOptions}>
                                    <b>Filter By Seller: </b> <div className={styles.selectionControl}>
                                        <select name="seller_id" id="" onChange={(e: any) => inputHandler(e)} >
                                            <option value="">Select Seller</option>
                                            {
                                                sellerList.map((item: any) => (
                                                    <option value={item?.seller_id} key={item?.seller_id}>{item?.name}</option>
                                                ))
                                            }

                                        </select></div></div>
                                : ""} */}
                        </div>

                        <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap}`} style={{ minHeight: "60vh" }}>
                            {
                                userloading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <>
                                        <div className={styles.desktopTable}>
                                            <Paginated data={userlist} columns={COLUMNS} />
                                        </div>
                                        <div className={styles.mobileList}>
                                            <Sellerpagination itemsPerPage={20} items={userlist} sellerDelete={userDelete} paginationFor="user"></Sellerpagination>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </ThemeMaker>
        </>
    )
}

export default UserList;